import { render, staticRenderFns } from "./DraftIcon.vue?vue&type=template&id=d0f5bf04&"
import script from "./DraftIcon.vue?vue&type=script&lang=js&"
export * from "./DraftIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports